// Swiper core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// init all swipers (sliders) on the page after DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // get all swiper unique ids
  const swipers = document.querySelectorAll("[data-swiper-id]");

  // loop through each swiper and init it with its own unique id from the markup
  swipers.forEach((el) => {
    const swiperId = el.getAttribute("data-swiper-id");
    const slider = el.closest(".slider");
    const isAccordion = el.getAttribute("data-is-accordion") || false;
    const slideCount = el.querySelectorAll(".swiper-slide").length; // for slidesPerView - to stretch and fill the entire container if fewer slides

    const swiper = new Swiper(`.swiper-${swiperId}`, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 24,
      lazyPreloadPrevNext: 2,
      centeredSlides: false,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        prevEl: slider.querySelector(".swiper-button-prev-class"),
        nextEl: slider.querySelector(".swiper-button-next-class"),
      },
      breakpoints: {
        520: {
          slidesPerView: isAccordion ? 2 : slideCount < 3 ? 2 : 2.2,
        },
        768: {
          slidesPerView: isAccordion ? 2 : slideCount < 3 ? 2 : 3.2,
        },
        992: {
          slidesPerView: isAccordion ? 2 : slideCount < 4 ? slideCount : 4,
        },
      },
    });
  });
});
